import { render, staticRenderFns } from "./Competitions.vue?vue&type=template&id=08e5e454&"
import script from "./Competitions.vue?vue&type=script&lang=js&"
export * from "./Competitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports